import type { Call } from 'features/call/call-base/interfaces';
import type { CallState } from 'features/call/call-base/store';
import { sanitizePhoneExtension } from 'features/call/call-hearing/helpers/sanitizePhoneExtension';

export const adaptIncomingCall = (call: Call): Partial<CallState> => {
  return {
    id: call.Id,
    languageCode: call.LanguageCode,
    callerName: call.CallerName,
    genderRequest: call.GenderRequest,
    isDeafToHearing: call.IsDeafToHearing,
    isCanBeTransferred: call.CanBeTransferred,
    callerConnectionType: call.CallerConnectionType,
    isHearingCallerIdBlocked: call.IsInboundHearingCallerIdBlocked,
    registrationType: call.RegistrationType,
    registrationFailureCode: call.RegistrationFailureCode,
    vcoPreference: call.VcoPreference ?? null,
    calleeCoreMyPhoneGroupOwnerId: call.CalleeCoreMyPhoneGroupOwnerId ?? null,
    calleeCoreUserId: call.CalleeCoreUserId ?? null,
    endpointMacAddress: call.EndpointMacAddress,
    calleeConnectionString: call.CalleeConnectionString,
    hearingPhoneExtension: sanitizePhoneExtension(
      call.HearingPhoneExtension ?? ''
    ),
    DeafIpTraceback: call.DeafIpTraceback,
  };
};
